import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, Grid, MenuItem, Select } from '@mui/material';
import PopupTitle from '../common/popup_title';

const SpaceRecipesNewSectionModal = ({
  anchorEl,
  availableSections,
  onDismiss,
  onSave,
}) => {
  const [selectedMenuTitle, setSelectedMenuTitle] = useState(null);

  const isValid = selectedMenuTitle !== null;

  return (
    <Dialog
      open
      // size="md"
      PaperProps={{
        style: {
          width: '420px',
          height: '160px',
          padding: '10px',
        },
      }}
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'center', horizontal: 'left' }}
      onClose={onDismiss}>
      <Grid container>
        <Grid item xs={12}>
          <PopupTitle
            closeButtonEnabled
            onClickClose={onDismiss}
            titleText="Add new section"
          />
        </Grid>
        <Grid item xs={12} style={{ padding: '5px' }}>
          Select recipes section
        </Grid>
        <Grid item xs={12} style={{ padding: '5px' }}>
          <Select
            variant="standard"
            fullWidth
            displayEmpty
            value={selectedMenuTitle}
            onChange={(ev) => {
              setSelectedMenuTitle(ev.target.value);
            }}
            inputProps={{ 'aria-label': 'Without label' }}>
            <MenuItem disabled value="">
              <em>Select from the dropdown list</em>
            </MenuItem>
            {availableSections.map((menuTitle) => {
              return (
                <MenuItem key={menuTitle} value={menuTitle}>
                  {menuTitle}
                </MenuItem>
              );
            })}
          </Select>
        </Grid>
        <Grid item xs={12} style={{ padding: '5px' }}>
          <Button
            onClick={(ev) => {
              onSave(selectedMenuTitle);
              ev.stopPropagation();
            }}
            variant="contained"
            size="medium"
            disabled={!isValid}
            disableElevation>
            Save
          </Button>
          <Button
            onClick={(ev) => {
              onDismiss();
              ev.stopPropagation();
            }}
            variant="contained"
            color="secondary"
            size="medium"
            style={{ marginLeft: '6px' }}
            disableElevation>
            Cancel
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

SpaceRecipesNewSectionModal.propTypes = {
  anchorEl: PropTypes.element.isRequired,
  availableSections: PropTypes.arrayOf(
    PropTypes.shape({
      publishedSectionType: PropTypes.string.isRequired,
      contentLane: PropTypes.shape({}),
    }),
  ).isRequired,
  onDismiss: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default SpaceRecipesNewSectionModal;
